module.exports = __webpack_public_path__ + "img/save_to_bookmarks.f8d79428.svg";